import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { FlatFileListItem } from '@/components/modules/List/FlatFileList/FlatFileListItem';
import { Text } from '@/components/ui/Typography/Body/Text';
/**
 * 画像一覧表示
 * @param props
 * @returns
 */
export const FlatFileList = (props) => {
    const { className = '', items = [], noItemText } = props;
    if (!items.length) {
        return (_jsx(Text, Object.assign({ color: 'base', size: 'sm' }, { children: noItemText || '画像はありません' })));
    }
    return (_jsx("ul", Object.assign({ className: clsx('flex flex-col gap-y-8', className) }, { children: items.map((item, index) => (_jsx(FlatFileListItem, { file: item.file, name: item.name, path: item.path }, `${item.name}_${index + 1}`))) })));
};
